(function () {
  'use strict';

  const selectors = {
    input: '[data-popout-input]',
    toggle: '[data-popout-toggle]',
    item: '.select-popout__item',
    option: '[data-popout-option]',
    error: '[data-ring-size-error]',
    cartBarAdd: '[data-cart-bar-add-to-cart]',
  };

  const classes = {
    active: 'is-active',
    error: 'is-error',
    loading: 'is-loading',
  };

  class RingSizeSelect extends HTMLElement {
    constructor() {
      super();

      this.onChange = this.onChange.bind(this);
      this.onInvalid = this.onInvalid.bind(this);
    }

    connectedCallback() {
      this.input = this.querySelector(selectors.input);
      this.toggle = this.querySelector(selectors.toggle);
      this.error = this.querySelector(selectors.error);
      this.items = Array.from(this.querySelectorAll(selectors.item));

      if (!this.input) return;

      this.input.addEventListener('change', this.onChange);
      this.input.addEventListener('invalid', this.onInvalid);

      this.syncSelectedOption();
    }

    disconnectedCallback() {
      if (!this.input) return;

      this.input.removeEventListener('change', this.onChange);
      this.input.removeEventListener('invalid', this.onInvalid);
    }

    onChange() {
      this.syncSelectedOption();
      this.hideError();
    }

    // The invalid event fires when the product form runs checkValidity()/reportValidity() on submit.
    // Suppress the native bubble (the input is visually hidden) and show an inline message instead.
    onInvalid(evt) {
      evt.preventDefault();

      this.showError();
      this.resetCartBarButton();
      this.scrollIntoView({behavior: 'smooth', block: 'center'});
    }

    // Highlight the chosen size in the list; the popout only does this when an option is preselected
    syncSelectedOption() {
      const value = this.input.value;

      this.items.forEach((item) => {
        const option = item.querySelector(selectors.option);
        const isSelected = value !== '' && option && option.getAttribute('data-value') === value;

        item.classList.toggle(classes.active, isSelected);

        if (!option) return;

        if (isSelected) {
          option.setAttribute('aria-current', 'true');
        } else {
          option.removeAttribute('aria-current');
        }
      });
    }

    showError() {
      this.classList.add(classes.error);

      if (this.error) this.error.removeAttribute('hidden');
      if (this.toggle) this.toggle.setAttribute('aria-invalid', 'true');
    }

    hideError() {
      this.classList.remove(classes.error);

      if (this.error) this.error.setAttribute('hidden', '');
      if (this.toggle) this.toggle.removeAttribute('aria-invalid');
    }

    // The sticky cart bar disables its button before the form is validated; re-enable it so the customer can retry
    resetCartBarButton() {
      const cartBarButton = document.querySelector(selectors.cartBarAdd);

      if (!cartBarButton) return;

      cartBarButton.classList.remove(classes.loading);
      cartBarButton.removeAttribute('disabled');
    }
  }

  if (!customElements.get('ring-size-select')) {
    customElements.define('ring-size-select', RingSizeSelect);
  }
})();
